interface HealthBarProps {
  hp: number;
  maxHp: number;
  label: string;
  side: "player" | "bot";
}

export function HealthBar({ hp, maxHp, label, side }: HealthBarProps) {
  const percentage = Math.round((hp / maxHp) * 100);

  return (
    <div className={`fighter fighter--${side}`}>
      <span className="fighter__name" title={label}>{label}</span>
      <div
        className="health-bar"
        role="meter"
        aria-label={`${label}: ${hp}/${maxHp}`}
        aria-valuemin={0}
        aria-valuemax={maxHp}
        aria-valuenow={hp}
      >
        <span className="health-bar__fill" style={{ width: `${percentage}%` }} />
        <span className="health-bar__value">{hp}/{maxHp}</span>
      </div>
    </div>
  );
}
